import {
  Adrenals,
  Ankles,
  Annotate,
  Bladder,
  Bowel,
  Brain,
  Breast,
  Esophagus,
  Gallbladder,
  Heart,
  Image,
  InformationCircle,
  Kidneys,
  Knees,
  Liver,
  Lungs,
  Neck,
  Ovaries,
  Pancreas,
  Pelvis,
  Prostate,
  SacroliacJoints,
  Shoulders,
  Sinus,
  Skleleton,
  Spine,
  Spleen,
  Star,
  Stomach,
  Uterus,
} from '@prenuvo/halo-icon';

import { CareServiceOrgansSubKey } from '@/api';
import { CareServiceOrganItem } from '@/shared/model';

export const NECK_DESIRED_ORDER: CareServiceOrgansSubKey[] = [
  'nasal_pharynx',
  'oral_pharynx',
  'hypopharynx',
  'thyroid',
  'neck_lymph_nodes',
  'cervical_lymph_node_chain',
];

export const CARE_SERVICE_ORGAN_FULL_LIST: CareServiceOrganItem[] = [
  {
    key: 'body_composition',
    sub: [],
    value: 'Body composition',
  },
  {
    key: 'brain',
    sub: [],
    value: 'Brain',
  },
  {
    key: 'sinuses_and_mastoids',
    sub: [],
    value: 'Sinuses and mastoids',
  },
  {
    key: 'neck',
    sub: [
      {
        key: 'nasal_pharynx',
        value: 'Nasal pharynx',
      },
      {
        key: 'oral_pharynx',
        value: 'Oral pharynx',
      },
      {
        key: 'hypopharynx',
        value: 'Hypopharynx',
      },
      {
        key: 'thyroid',
        value: 'Thyroid',
      },
      {
        key: 'cervical_lymph_node_chain',
        value: 'Cervical lymph node chain',
      },
    ],
    value: 'Neck',
  },
  {
    key: 'lungs_and_mediastinum',
    sub: [],
    value: 'Lungs and mediastinum',
  },
  {
    key: 'heart_and_great_vessels',
    sub: [],
    value: 'Heart and vessels',
  },
  {
    key: 'breasts',
    sub: [],
    value: 'Breasts',
  },
  {
    key: 'esophagus',
    sub: [],
    value: 'Esophagus',
  },
  {
    key: 'stomach',
    sub: [],
    value: 'Stomach',
  },
  {
    key: 'liver',
    sub: [],
    value: 'Liver',
  },
  {
    key: 'gallbladder_and_biliary_system',
    sub: [],
    value: 'Gallbladder',
  },
  {
    key: 'pancreas',
    sub: [],
    value: 'Pancreas',
  },
  {
    key: 'spleen',
    sub: [],
    value: 'Spleen',
  },
  {
    key: 'adrenals',
    sub: [],
    value: 'Adrenals',
  },
  {
    key: 'kidneys',
    sub: [],
    value: 'Kidneys',
  },
  {
    key: 'bowel',
    sub: [],
    value: 'Bowel',
  },
  {
    key: 'bladder_and_ureters',
    sub: [],
    value: 'Bladder',
  },
  {
    key: 'uterus',
    sub: [],
    value: 'Uterus',
  },
  {
    key: 'ovaries',
    sub: [],
    value: 'Ovaries',
  },
  {
    key: 'prostate',
    sub: [],
    value: 'Prostate and testicles',
  },
  {
    key: 'spine',
    sub: [],
    value: 'Spine',
  },
  {
    key: 'shoulders',
    sub: [],
    value: 'Shoulders',
  },
  {
    key: 'sacroiliac_joints',
    sub: [],
    value: 'Sacroiliac joints',
  },
  {
    key: 'pelvis_and_hips',
    sub: [],
    value: 'Pelvis and hips',
  },
  {
    key: 'knees',
    sub: [],
    value: 'Knees',
  },
  {
    key: 'ankles',
    sub: [],
    value: 'Ankles',
  },
  {
    key: 'bony_skeleton',
    sub: [],
    value: 'Skeleton and soft tissues',
  },
];

export const NAV_ICON_MAP = {
  adrenals: Adrenals,
  ai_findings: InformationCircle,
  ankles: Ankles,
  bladder_and_ureters: Bladder,
  body_composition: InformationCircle,
  bony_skeleton: Skleleton,
  bowel: Bowel,
  brain: Brain,
  breasts: Breast,
  cervical_lymph_node_chain: Neck,
  esophagus: Esophagus,
  final_impressions: Star,
  gallbladder_and_biliary_system: Gallbladder,
  heart_and_great_vessels: Heart,
  hypopharynx: Neck,
  key_images: Image,
  kidneys: Kidneys,
  knees: Knees,
  liver: Liver,
  lungs_and_mediastinum: Lungs,
  nasal_pharynx: Neck,
  neck: Neck,
  neck_lymph_nodes: Neck,
  oral_pharynx: Neck,
  other_organs: InformationCircle,
  ovaries: Ovaries,
  pancreas: Pancreas,
  pelvis_and_hips: Pelvis,
  preview: Annotate,
  prostate: Prostate,
  quality_review: InformationCircle,
  reason_for_scan: InformationCircle,
  sacroiliac_joints: SacroliacJoints,
  shoulders: Shoulders,
  sinuses_and_mastoids: Sinus,
  spine: Spine,
  spleen: Spleen,
  stomach: Stomach,
  thyroid: Neck,
  uterus: Uterus,
} as const;

export type NavIconKey = keyof typeof NAV_ICON_MAP;

export const OTHER_ORGANS = 'Other organs';

export const FEMALE_ORGANS: string[] = ['breasts', 'uterus', 'ovaries'];

export const MALE_ORGANS: string[] = ['prostate'];
